(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('rent-invoices', {
            parent: 'admin',
            url: '/rent-invoices',
            data: {
                authorities: ['UPDATE_TRANSACTION_STATUS'],
                pageTitle: 'rent.home.title'
            },
            views: {
                'content@app': {
                    templateUrl: 'app/admin/rent-invoices/rent.html',
                    controller: 'RentInvoicesController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                type: null
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('rent-invoice');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }
})();
